export default __webpack_public_path__ + "static/media/Key.bea5b7ca.svg";